import { ReadOccupancyRateState, OccupancyRateActionTypes, READ_OCCUPANCY_RATE_DATA_REQUEST, READ_OCCUPANCY_RATE_DATA_SUCCESS, READ_OCCUPANCY_RATE_DATA_FAILURE } from "store/reducers/room/readOccupancyRateData/types";

const defaultState: ReadOccupancyRateState = {
  isLoading: false,
  errorMessage: ""
};

export default function occupancyRate(state = defaultState, action: OccupancyRateActionTypes): ReadOccupancyRateState {
  switch (action.type) {
    case READ_OCCUPANCY_RATE_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_OCCUPANCY_RATE_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_OCCUPANCY_RATE_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};